import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';

export const AttachmentsHeader = (): ReactElement => {
  const { t } = useTranslator();
  return <HeaderWithDescription header={t('attachments_header')} />;
};
